/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PAC API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateCustomReportDto,
  CustomReportsResponseDto,
  DomainErrorDto,
  GetSalesOrderFilterColumnsResponseDto,
  GetSalesOrderNotesDto,
  GetSalesOrderReportsResponseDto,
  GetSalesOrderWorkOrdersDto,
  GetSalesOrdersResponseDto,
  NoteInputDto,
  SalesOrderControllerCreateSalesOrderNoteWithAttachmentsBody,
  SalesOrderControllerGetSalesOrdersParams,
  SalesOrderDto,
  UpdateCustomReportDto
} from './pacApi.schemas';

import { axios } from '../../common/axios';
import type { ErrorType , BodyType } from '../../common/axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const salesOrderControllerGetSalesOrderByExternalId = (
    salesOrderExternalId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<SalesOrderDto>(
      {url: `/api/v1/finance/sales-orders/by-id/${salesOrderExternalId}`, method: 'GET', signal
    },
      options);
    }




export const getSalesOrderControllerGetSalesOrderByExternalIdQueryKey = (salesOrderExternalId: string,) => {
    return [
    `/api/v1/finance/sales-orders/by-id/${salesOrderExternalId}`
    ] as const;
    }


export const getSalesOrderControllerGetSalesOrderByExternalIdQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError = ErrorType<DomainErrorDto>>(salesOrderExternalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrderByExternalIdQueryKey(salesOrderExternalId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>> = ({ signal }) => salesOrderControllerGetSalesOrderByExternalId(salesOrderExternalId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(salesOrderExternalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrderByExternalIdQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>>
export type SalesOrderControllerGetSalesOrderByExternalIdQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrderByExternalId<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderExternalId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderByExternalId<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderExternalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderByExternalId<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderExternalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrderByExternalId<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderExternalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrderByExternalIdQueryOptions(salesOrderExternalId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getSalesOrderControllerGetSalesOrderByExternalIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError = ErrorType<DomainErrorDto>>(salesOrderExternalId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrderByExternalIdQueryKey(salesOrderExternalId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>> = ({ signal }) => salesOrderControllerGetSalesOrderByExternalId(salesOrderExternalId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrderByExternalIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>>
export type SalesOrderControllerGetSalesOrderByExternalIdSuspenseQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrderByExternalIdSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderExternalId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderByExternalIdSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderExternalId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderByExternalIdSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderExternalId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrderByExternalIdSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderExternalId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderByExternalId>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrderByExternalIdSuspenseQueryOptions(salesOrderExternalId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const salesOrderControllerGetSalesOrderWorkOrders = (
    salesOrderId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetSalesOrderWorkOrdersDto>(
      {url: `/api/v1/finance/sales-orders/${salesOrderId}/work-orders`, method: 'GET', signal
    },
      options);
    }




export const getSalesOrderControllerGetSalesOrderWorkOrdersQueryKey = (salesOrderId: string,) => {
    return [
    `/api/v1/finance/sales-orders/${salesOrderId}/work-orders`
    ] as const;
    }


export const getSalesOrderControllerGetSalesOrderWorkOrdersQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError = ErrorType<DomainErrorDto>>(salesOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrderWorkOrdersQueryKey(salesOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>> = ({ signal }) => salesOrderControllerGetSalesOrderWorkOrders(salesOrderId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(salesOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrderWorkOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>>
export type SalesOrderControllerGetSalesOrderWorkOrdersQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrderWorkOrders<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderWorkOrders<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderWorkOrders<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrderWorkOrders<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrderWorkOrdersQueryOptions(salesOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getSalesOrderControllerGetSalesOrderWorkOrdersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError = ErrorType<DomainErrorDto>>(salesOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrderWorkOrdersQueryKey(salesOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>> = ({ signal }) => salesOrderControllerGetSalesOrderWorkOrders(salesOrderId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrderWorkOrdersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>>
export type SalesOrderControllerGetSalesOrderWorkOrdersSuspenseQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrderWorkOrdersSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderWorkOrdersSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderWorkOrdersSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrderWorkOrdersSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrderWorkOrdersSuspenseQueryOptions(salesOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const salesOrderControllerGetSalesOrderNotes = (
    salesOrderId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetSalesOrderNotesDto>(
      {url: `/api/v1/finance/sales-orders/${salesOrderId}/notes`, method: 'GET', signal
    },
      options);
    }




export const getSalesOrderControllerGetSalesOrderNotesQueryKey = (salesOrderId: string,) => {
    return [
    `/api/v1/finance/sales-orders/${salesOrderId}/notes`
    ] as const;
    }


export const getSalesOrderControllerGetSalesOrderNotesQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError = ErrorType<DomainErrorDto>>(salesOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrderNotesQueryKey(salesOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>> = ({ signal }) => salesOrderControllerGetSalesOrderNotes(salesOrderId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(salesOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrderNotesQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>>
export type SalesOrderControllerGetSalesOrderNotesQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrderNotes<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderNotes<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderNotes<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrderNotes<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrderNotesQueryOptions(salesOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getSalesOrderControllerGetSalesOrderNotesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError = ErrorType<DomainErrorDto>>(salesOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrderNotesQueryKey(salesOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>> = ({ signal }) => salesOrderControllerGetSalesOrderNotes(salesOrderId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrderNotesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>>
export type SalesOrderControllerGetSalesOrderNotesSuspenseQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrderNotesSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderNotesSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderNotesSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrderNotesSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNotes>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrderNotesSuspenseQueryOptions(salesOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const salesOrderControllerCreateSalesOrderNote = (
    salesOrderId: string,
    noteInputDto: BodyType<NoteInputDto>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetSalesOrderNotesDto>(
      {url: `/api/v1/finance/sales-orders/${salesOrderId}/notes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: noteInputDto, signal
    },
      options);
    }



export const getSalesOrderControllerCreateSalesOrderNoteMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerCreateSalesOrderNote>>, TError,{salesOrderId: string;data: BodyType<NoteInputDto>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerCreateSalesOrderNote>>, TError,{salesOrderId: string;data: BodyType<NoteInputDto>}, TContext> => {

const mutationKey = ['salesOrderControllerCreateSalesOrderNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof salesOrderControllerCreateSalesOrderNote>>, {salesOrderId: string;data: BodyType<NoteInputDto>}> = (props) => {
          const {salesOrderId,data} = props ?? {};

          return  salesOrderControllerCreateSalesOrderNote(salesOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SalesOrderControllerCreateSalesOrderNoteMutationResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerCreateSalesOrderNote>>>
    export type SalesOrderControllerCreateSalesOrderNoteMutationBody = BodyType<NoteInputDto>
    export type SalesOrderControllerCreateSalesOrderNoteMutationError = ErrorType<DomainErrorDto>

    export const useSalesOrderControllerCreateSalesOrderNote = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerCreateSalesOrderNote>>, TError,{salesOrderId: string;data: BodyType<NoteInputDto>}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof salesOrderControllerCreateSalesOrderNote>>,
        TError,
        {salesOrderId: string;data: BodyType<NoteInputDto>},
        TContext
      > => {
      return useMutation(getSalesOrderControllerCreateSalesOrderNoteMutationOptions(options), queryClient);
    }
    export const salesOrderControllerCreateSalesOrderNoteWithAttachments = (
    salesOrderId: string,
    salesOrderControllerCreateSalesOrderNoteWithAttachmentsBody: BodyType<SalesOrderControllerCreateSalesOrderNoteWithAttachmentsBody>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`message`, salesOrderControllerCreateSalesOrderNoteWithAttachmentsBody.message);
salesOrderControllerCreateSalesOrderNoteWithAttachmentsBody.files.forEach(value => formData.append(`files`, value));

      return axios<GetSalesOrderNotesDto>(
      {url: `/api/v1/finance/sales-orders/${salesOrderId}/notes/with-attachments`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }



export const getSalesOrderControllerCreateSalesOrderNoteWithAttachmentsMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerCreateSalesOrderNoteWithAttachments>>, TError,{salesOrderId: string;data: BodyType<SalesOrderControllerCreateSalesOrderNoteWithAttachmentsBody>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerCreateSalesOrderNoteWithAttachments>>, TError,{salesOrderId: string;data: BodyType<SalesOrderControllerCreateSalesOrderNoteWithAttachmentsBody>}, TContext> => {

const mutationKey = ['salesOrderControllerCreateSalesOrderNoteWithAttachments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof salesOrderControllerCreateSalesOrderNoteWithAttachments>>, {salesOrderId: string;data: BodyType<SalesOrderControllerCreateSalesOrderNoteWithAttachmentsBody>}> = (props) => {
          const {salesOrderId,data} = props ?? {};

          return  salesOrderControllerCreateSalesOrderNoteWithAttachments(salesOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SalesOrderControllerCreateSalesOrderNoteWithAttachmentsMutationResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerCreateSalesOrderNoteWithAttachments>>>
    export type SalesOrderControllerCreateSalesOrderNoteWithAttachmentsMutationBody = BodyType<SalesOrderControllerCreateSalesOrderNoteWithAttachmentsBody>
    export type SalesOrderControllerCreateSalesOrderNoteWithAttachmentsMutationError = ErrorType<DomainErrorDto>

    export const useSalesOrderControllerCreateSalesOrderNoteWithAttachments = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerCreateSalesOrderNoteWithAttachments>>, TError,{salesOrderId: string;data: BodyType<SalesOrderControllerCreateSalesOrderNoteWithAttachmentsBody>}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof salesOrderControllerCreateSalesOrderNoteWithAttachments>>,
        TError,
        {salesOrderId: string;data: BodyType<SalesOrderControllerCreateSalesOrderNoteWithAttachmentsBody>},
        TContext
      > => {
      return useMutation(getSalesOrderControllerCreateSalesOrderNoteWithAttachmentsMutationOptions(options), queryClient);
    }
    export const salesOrderControllerUpdateSalesOrderNote = (
    salesOrderId: string,
    salesOrderNoteId: string,
    noteInputDto: BodyType<NoteInputDto>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetSalesOrderNotesDto>(
      {url: `/api/v1/finance/sales-orders/${salesOrderId}/notes/${salesOrderNoteId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: noteInputDto, signal
    },
      options);
    }



export const getSalesOrderControllerUpdateSalesOrderNoteMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerUpdateSalesOrderNote>>, TError,{salesOrderId: string;salesOrderNoteId: string;data: BodyType<NoteInputDto>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerUpdateSalesOrderNote>>, TError,{salesOrderId: string;salesOrderNoteId: string;data: BodyType<NoteInputDto>}, TContext> => {

const mutationKey = ['salesOrderControllerUpdateSalesOrderNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof salesOrderControllerUpdateSalesOrderNote>>, {salesOrderId: string;salesOrderNoteId: string;data: BodyType<NoteInputDto>}> = (props) => {
          const {salesOrderId,salesOrderNoteId,data} = props ?? {};

          return  salesOrderControllerUpdateSalesOrderNote(salesOrderId,salesOrderNoteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SalesOrderControllerUpdateSalesOrderNoteMutationResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerUpdateSalesOrderNote>>>
    export type SalesOrderControllerUpdateSalesOrderNoteMutationBody = BodyType<NoteInputDto>
    export type SalesOrderControllerUpdateSalesOrderNoteMutationError = ErrorType<DomainErrorDto>

    export const useSalesOrderControllerUpdateSalesOrderNote = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerUpdateSalesOrderNote>>, TError,{salesOrderId: string;salesOrderNoteId: string;data: BodyType<NoteInputDto>}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof salesOrderControllerUpdateSalesOrderNote>>,
        TError,
        {salesOrderId: string;salesOrderNoteId: string;data: BodyType<NoteInputDto>},
        TContext
      > => {
      return useMutation(getSalesOrderControllerUpdateSalesOrderNoteMutationOptions(options), queryClient);
    }
    export const salesOrderControllerGetSalesOrderNoteAttachment = (
    salesOrderId: string,
    salesOrderNoteId: string,
    attachmentId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<Blob>(
      {url: `/api/v1/finance/sales-orders/${salesOrderId}/notes/${salesOrderNoteId}/attachments/${attachmentId}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getSalesOrderControllerGetSalesOrderNoteAttachmentQueryKey = (salesOrderId: string,
    salesOrderNoteId: string,
    attachmentId: string,) => {
    return [
    `/api/v1/finance/sales-orders/${salesOrderId}/notes/${salesOrderNoteId}/attachments/${attachmentId}`
    ] as const;
    }


export const getSalesOrderControllerGetSalesOrderNoteAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError = ErrorType<DomainErrorDto>>(salesOrderId: string,
    salesOrderNoteId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrderNoteAttachmentQueryKey(salesOrderId,salesOrderNoteId,attachmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>> = ({ signal }) => salesOrderControllerGetSalesOrderNoteAttachment(salesOrderId,salesOrderNoteId,attachmentId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(salesOrderId && salesOrderNoteId && attachmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrderNoteAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>>
export type SalesOrderControllerGetSalesOrderNoteAttachmentQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrderNoteAttachment<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string,
    salesOrderNoteId: string,
    attachmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderNoteAttachment<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string,
    salesOrderNoteId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderNoteAttachment<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string,
    salesOrderNoteId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrderNoteAttachment<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string,
    salesOrderNoteId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrderNoteAttachmentQueryOptions(salesOrderId,salesOrderNoteId,attachmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getSalesOrderControllerGetSalesOrderNoteAttachmentSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError = ErrorType<DomainErrorDto>>(salesOrderId: string,
    salesOrderNoteId: string,
    attachmentId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrderNoteAttachmentQueryKey(salesOrderId,salesOrderNoteId,attachmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>> = ({ signal }) => salesOrderControllerGetSalesOrderNoteAttachment(salesOrderId,salesOrderNoteId,attachmentId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrderNoteAttachmentSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>>
export type SalesOrderControllerGetSalesOrderNoteAttachmentSuspenseQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrderNoteAttachmentSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string,
    salesOrderNoteId: string,
    attachmentId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderNoteAttachmentSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string,
    salesOrderNoteId: string,
    attachmentId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderNoteAttachmentSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string,
    salesOrderNoteId: string,
    attachmentId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrderNoteAttachmentSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string,
    salesOrderNoteId: string,
    attachmentId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderNoteAttachment>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrderNoteAttachmentSuspenseQueryOptions(salesOrderId,salesOrderNoteId,attachmentId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const salesOrderControllerGetSalesOrders = (
    params?: SalesOrderControllerGetSalesOrdersParams,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetSalesOrdersResponseDto>(
      {url: `/api/v1/finance/sales-orders/query`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSalesOrderControllerGetSalesOrdersQueryKey = (params?: SalesOrderControllerGetSalesOrdersParams,) => {
    return [
    `/api/v1/finance/sales-orders/query`, ...(params ? [params] : [])
    ] as const;
    }


export const getSalesOrderControllerGetSalesOrdersQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError = ErrorType<DomainErrorDto>>(params?: SalesOrderControllerGetSalesOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>> = ({ signal }) => salesOrderControllerGetSalesOrders(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>>
export type SalesOrderControllerGetSalesOrdersQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrders<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError = ErrorType<DomainErrorDto>>(
 params: undefined |  SalesOrderControllerGetSalesOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrders<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError = ErrorType<DomainErrorDto>>(
 params?: SalesOrderControllerGetSalesOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrders<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError = ErrorType<DomainErrorDto>>(
 params?: SalesOrderControllerGetSalesOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrders<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError = ErrorType<DomainErrorDto>>(
 params?: SalesOrderControllerGetSalesOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getSalesOrderControllerGetSalesOrdersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError = ErrorType<DomainErrorDto>>(params?: SalesOrderControllerGetSalesOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>> = ({ signal }) => salesOrderControllerGetSalesOrders(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrdersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>>
export type SalesOrderControllerGetSalesOrdersSuspenseQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrdersSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError = ErrorType<DomainErrorDto>>(
 params: undefined |  SalesOrderControllerGetSalesOrdersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrdersSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError = ErrorType<DomainErrorDto>>(
 params?: SalesOrderControllerGetSalesOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrdersSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError = ErrorType<DomainErrorDto>>(
 params?: SalesOrderControllerGetSalesOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrdersSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError = ErrorType<DomainErrorDto>>(
 params?: SalesOrderControllerGetSalesOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrdersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const salesOrderControllerGetSalesOrderFilterColumns = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetSalesOrderFilterColumnsResponseDto>(
      {url: `/api/v1/finance/sales-orders/query/filter-columns`, method: 'GET', signal
    },
      options);
    }




export const getSalesOrderControllerGetSalesOrderFilterColumnsQueryKey = () => {
    return [
    `/api/v1/finance/sales-orders/query/filter-columns`
    ] as const;
    }


export const getSalesOrderControllerGetSalesOrderFilterColumnsQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrderFilterColumnsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>> = ({ signal }) => salesOrderControllerGetSalesOrderFilterColumns(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrderFilterColumnsQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>>
export type SalesOrderControllerGetSalesOrderFilterColumnsQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrderFilterColumns<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderFilterColumns<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderFilterColumns<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrderFilterColumns<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrderFilterColumnsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getSalesOrderControllerGetSalesOrderFilterColumnsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrderFilterColumnsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>> = ({ signal }) => salesOrderControllerGetSalesOrderFilterColumns(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrderFilterColumnsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>>
export type SalesOrderControllerGetSalesOrderFilterColumnsSuspenseQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrderFilterColumnsSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderFilterColumnsSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderFilterColumnsSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrderFilterColumnsSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrderFilterColumnsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const salesOrderControllerGetSalesOrderReports = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetSalesOrderReportsResponseDto>(
      {url: `/api/v1/finance/sales-orders/query/reports`, method: 'GET', signal
    },
      options);
    }




export const getSalesOrderControllerGetSalesOrderReportsQueryKey = () => {
    return [
    `/api/v1/finance/sales-orders/query/reports`
    ] as const;
    }


export const getSalesOrderControllerGetSalesOrderReportsQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrderReportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>> = ({ signal }) => salesOrderControllerGetSalesOrderReports(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrderReportsQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>>
export type SalesOrderControllerGetSalesOrderReportsQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrderReports<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderReports<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderReports<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrderReports<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrderReportsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getSalesOrderControllerGetSalesOrderReportsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrderReportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>> = ({ signal }) => salesOrderControllerGetSalesOrderReports(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrderReportsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>>
export type SalesOrderControllerGetSalesOrderReportsSuspenseQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrderReportsSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderReportsSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderReportsSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrderReportsSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrderReportsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const salesOrderControllerGetCustomReports = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<CustomReportsResponseDto>(
      {url: `/api/v1/finance/sales-orders/query/custom-reports`, method: 'GET', signal
    },
      options);
    }




export const getSalesOrderControllerGetCustomReportsQueryKey = () => {
    return [
    `/api/v1/finance/sales-orders/query/custom-reports`
    ] as const;
    }


export const getSalesOrderControllerGetCustomReportsQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetCustomReportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>> = ({ signal }) => salesOrderControllerGetCustomReports(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetCustomReportsQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>>
export type SalesOrderControllerGetCustomReportsQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetCustomReports<TData = Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetCustomReports<TData = Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetCustomReports<TData = Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetCustomReports<TData = Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetCustomReportsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getSalesOrderControllerGetCustomReportsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetCustomReportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>> = ({ signal }) => salesOrderControllerGetCustomReports(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetCustomReportsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>>
export type SalesOrderControllerGetCustomReportsSuspenseQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetCustomReportsSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetCustomReportsSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetCustomReportsSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetCustomReportsSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetCustomReportsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const salesOrderControllerCreateCustomReport = (
    createCustomReportDto: BodyType<CreateCustomReportDto>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<CustomReportsResponseDto>(
      {url: `/api/v1/finance/sales-orders/query/custom-reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCustomReportDto, signal
    },
      options);
    }



export const getSalesOrderControllerCreateCustomReportMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerCreateCustomReport>>, TError,{data: BodyType<CreateCustomReportDto>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerCreateCustomReport>>, TError,{data: BodyType<CreateCustomReportDto>}, TContext> => {

const mutationKey = ['salesOrderControllerCreateCustomReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof salesOrderControllerCreateCustomReport>>, {data: BodyType<CreateCustomReportDto>}> = (props) => {
          const {data} = props ?? {};

          return  salesOrderControllerCreateCustomReport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SalesOrderControllerCreateCustomReportMutationResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerCreateCustomReport>>>
    export type SalesOrderControllerCreateCustomReportMutationBody = BodyType<CreateCustomReportDto>
    export type SalesOrderControllerCreateCustomReportMutationError = ErrorType<DomainErrorDto>

    export const useSalesOrderControllerCreateCustomReport = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerCreateCustomReport>>, TError,{data: BodyType<CreateCustomReportDto>}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof salesOrderControllerCreateCustomReport>>,
        TError,
        {data: BodyType<CreateCustomReportDto>},
        TContext
      > => {
      return useMutation(getSalesOrderControllerCreateCustomReportMutationOptions(options), queryClient);
    }
    export const salesOrderControllerUpdateCustomReport = (
    reportId: string,
    updateCustomReportDto: BodyType<UpdateCustomReportDto>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<CustomReportsResponseDto>(
      {url: `/api/v1/finance/sales-orders/query/custom-reports/${reportId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCustomReportDto, signal
    },
      options);
    }



export const getSalesOrderControllerUpdateCustomReportMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerUpdateCustomReport>>, TError,{reportId: string;data: BodyType<UpdateCustomReportDto>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerUpdateCustomReport>>, TError,{reportId: string;data: BodyType<UpdateCustomReportDto>}, TContext> => {

const mutationKey = ['salesOrderControllerUpdateCustomReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof salesOrderControllerUpdateCustomReport>>, {reportId: string;data: BodyType<UpdateCustomReportDto>}> = (props) => {
          const {reportId,data} = props ?? {};

          return  salesOrderControllerUpdateCustomReport(reportId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SalesOrderControllerUpdateCustomReportMutationResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerUpdateCustomReport>>>
    export type SalesOrderControllerUpdateCustomReportMutationBody = BodyType<UpdateCustomReportDto>
    export type SalesOrderControllerUpdateCustomReportMutationError = ErrorType<DomainErrorDto>

    export const useSalesOrderControllerUpdateCustomReport = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerUpdateCustomReport>>, TError,{reportId: string;data: BodyType<UpdateCustomReportDto>}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof salesOrderControllerUpdateCustomReport>>,
        TError,
        {reportId: string;data: BodyType<UpdateCustomReportDto>},
        TContext
      > => {
      return useMutation(getSalesOrderControllerUpdateCustomReportMutationOptions(options), queryClient);
    }
    export const salesOrderControllerDeleteCustomReport = (
    reportId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<void>(
      {url: `/api/v1/finance/sales-orders/query/custom-reports/${reportId}`, method: 'DELETE', signal
    },
      options);
    }



export const getSalesOrderControllerDeleteCustomReportMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerDeleteCustomReport>>, TError,{reportId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerDeleteCustomReport>>, TError,{reportId: string}, TContext> => {

const mutationKey = ['salesOrderControllerDeleteCustomReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof salesOrderControllerDeleteCustomReport>>, {reportId: string}> = (props) => {
          const {reportId} = props ?? {};

          return  salesOrderControllerDeleteCustomReport(reportId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SalesOrderControllerDeleteCustomReportMutationResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerDeleteCustomReport>>>

    export type SalesOrderControllerDeleteCustomReportMutationError = ErrorType<DomainErrorDto>

    export const useSalesOrderControllerDeleteCustomReport = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof salesOrderControllerDeleteCustomReport>>, TError,{reportId: string}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof salesOrderControllerDeleteCustomReport>>,
        TError,
        {reportId: string},
        TContext
      > => {
      return useMutation(getSalesOrderControllerDeleteCustomReportMutationOptions(options), queryClient);
    }
    export const salesOrderControllerGetSalesOrder = (
    salesOrderId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<SalesOrderDto>(
      {url: `/api/v1/finance/sales-orders/${salesOrderId}`, method: 'GET', signal
    },
      options);
    }




export const getSalesOrderControllerGetSalesOrderQueryKey = (salesOrderId: string,) => {
    return [
    `/api/v1/finance/sales-orders/${salesOrderId}`
    ] as const;
    }


export const getSalesOrderControllerGetSalesOrderQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError = ErrorType<DomainErrorDto>>(salesOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrderQueryKey(salesOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>> = ({ signal }) => salesOrderControllerGetSalesOrder(salesOrderId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(salesOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrderQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>>
export type SalesOrderControllerGetSalesOrderQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrder<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrder<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>,
          TError,
          Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrder<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrder<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrderQueryOptions(salesOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getSalesOrderControllerGetSalesOrderSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError = ErrorType<DomainErrorDto>>(salesOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderControllerGetSalesOrderQueryKey(salesOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>> = ({ signal }) => salesOrderControllerGetSalesOrder(salesOrderId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderControllerGetSalesOrderSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>>
export type SalesOrderControllerGetSalesOrderSuspenseQueryError = ErrorType<DomainErrorDto>


export function useSalesOrderControllerGetSalesOrderSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderControllerGetSalesOrderSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderControllerGetSalesOrderSuspense<TData = Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError = ErrorType<DomainErrorDto>>(
 salesOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderControllerGetSalesOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderControllerGetSalesOrderSuspenseQueryOptions(salesOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






